import Error from '../common/errorData'
import CON from '../constant'
// import handleAjax from '../common/handleajax';
// import catchFn from '../common/catch';
import {
  http
} from './index'
const pasurl = CON.URL_DOWN

const getReq = (url, data) => { // 封装get参数
  const urls = http.adornUrl(url, pasurl)
  return http.get(urls, {
    params: data
  })
}
const postReq = (url, data) => { // 封装get参数
  const urls = http.adornUrl(url, pasurl)
  return http.post(urls, data)
}

export default {
  // 获取首页轮播图列表
  searchContent: (data) => getReq('/ndata/pc/home/searchContent', data).then(Error),
  pageContentMainByColumnId: (data) => getReq('/pc-api/cms/content-main/page', data).then(Error),
  pageContentMainByParentId: (data) => getReq('/ndata/pc/home/pageContentMainByParentId', data).then(Error),
  getParentColumn: (data) => getReq('/pc-api/cms/column/getColumn', data).then(Error),
  // 获取首页轮播图列表
  listAds: (data) => getReq('/pc-api/cms/ads/page', data).then(Error),
  listHomeVideozone: (data) => getReq('/pc-api/cms/special/home_page', data).then(Error),
  // 获取站点信息
  getWebsit: (data) => getReq('/pc-api/cms/websit/getWebsitByTenantId', data).then(Error),
  getLoginConfig: (data) => getReq('/pc-api/cms/websit/getLoginConfigByTenantId', data).then(Error),
  getPopularCourses: (data) => getReq('/app-api/app/course/index.action', data).then(Error),
  getContentMainNews: (data) => getReq('/pc-api/cms/column/getNewsAndList', data),
  listColumnTree: (data) => getReq('/pc-api/cms/column/select-tree-home', data).then(Error),
  getMainByColumnId: (data) => getReq('/pc-api/cms/content-main/page', data).then(Error),
  listColumn: (data) => getReq('/pc-api/cms/column/select-tree', data).then(Error),
  getMatchReport: (data) => getReq('/pc-api/cms/column/getMatchReport', data),
  pseudoLogin: (data) => postReq('/subscriber-api/forgot/login/pseudoLogin.action', data).then(Error)
}



// WEBPACK FOOTER //
// ./src/apis/home.js